/**
 * 基础路由
 * 
 * meta中自定义参数描述：
 * 1.keepAlive 是否缓存页面；仅当值等于true时才缓存，不配置此参数或值为false代表不缓存
 * 2.isShowTabbar 是否显示页面底部导航；仅当值等于true时才显示底部导航，不配置此参数或值为false代表不显示
 * 3.isShowOptionMenu 是否显示点击右上角出现微信分享、复制链接等功能；不配置此参数或值为false代表不显示
 * 4.wechatAuth 是否校验微信授权
 * 5.ifBind 是否校验用户绑定
 * 6.isHidFloatBall 是否隐藏悬浮球，不配置此参数或者值为false代表不隐藏
 * @type { *[] }
 */
export const constantRouterMap = [
	{
		path: '/',
		name: '根路径',
		redirect: '/index'
	},
	{
		path: '/index',
		name: 'index',
		component: () => import('@/views/index'),
		meta: {
			title: process.env.VUE_APP_HOSPITAL_NAME,
			keepAlive: false,
			isShowTabbar: true,
			isShowWxOptionMenu: true,
			wechatAuth: true,
			// ifBind: true,
			isHidFloatBall: true,
		}
	}, 
	{
		path: '/openModule',
		component: () => import('@/views/openModule'),
		meta: {
			title: '院内服务',
			keepAlive: false,
			isShowTabbar: true,
			isShowWxOptionMenu: true,
			wechatAuth: true,
			isHidFloatBall: true,
		}
	},
	{
		path: '/personalCenter',
		component: () => import('@/views/personalCenter'),
		meta: {
			title: '个人中心',
			keepAlive: false,
			isShowTabbar: true,
			isShowWxOptionMenu: true,
			wechatAuth: true,
			ifBind: true,
			isHidFloatBall: true,
		}
	}, 
	{
		path: '/patientAdd',
		component: () => import('@/views/patient/patientAdd'),
		meta: {
			title: '用户注册',
			wechatAuth: true
		}
	},
	{
		path: '/patientList',
		component: () => import('@/views/patient/patientList'),
		meta: {
			title: '就诊人列表',
			wechatAuth: true,
			ifBind: true,
		}
	}, 
	{
		path: '/patientCardList',
		component: () => import('@/views/patient/patientCardList'),
		meta: {
			title: '就诊卡包',
			wechatAuth: true,
			ifBind: true,
		}
	},
	{
		path: '/patientInfo',
		component: () => import('@/views/patient/patientInfo'),
		meta: {
			title: '个人信息',
			wechatAuth: true,
			ifBind: true,
		}
	}, 
	{
		path: '/h_index',
		component: () => import('@/views/hdTCM/hospital/index'),
		meta: {
			title: '医院简介',
		}
	},
	{
		path: '/doctor_index',
		component: () => import('@/views/hdTCM/doctor/doctor_index'),
		meta: {
			title: '医生列表',
			wechatAuth: true,
			ifBind: true,
		}
	},
	{
		path: '/doctor_detail',
		component: () => import('@/views/hdTCM/doctor/doctor_detail'),
		meta: {
			title: '医生简介',
			wechatAuth: true,
			ifBind: true,
		}
	},
	{
		path: '/menzDeptList/:flag',
		component: () => import('@/views/appointment/menzDeptList'),
		meta: {
			title: '门诊科室列表',
			wechatAuth: true,
			ifBind: true,
		}
	},
	{
		path: '/menzDrghDoctorList',
		component: () => import('@/views/appointment/menzDrghDoctorList'),
		meta: {
			title: '门诊医生列表',
		}
	},
	{
		path: '/menzYyghDoctorList',
		component: () => import('@/views/appointment/menzYyghDoctorList'),
		meta: {
			title: '门诊医生列表',
		}
	},
	{
		path: '/yyTips',
		component: () => import('@/views/appointment/yyTips'),
		meta: {
			title: '线上挂号须知',
		}
	},
	{
		path: '/menzDoctorDetail',
		component: () => import('@/views/appointment/menzDoctorDetail'),
		meta: {
			title: '门诊医生详情',
			wechatAuth: true,
			ifBind: true,
		}
	},
	{
		path: '/menzKesDetail',
		component: () => import('@/views/appointment/menzKesDetail'),
		meta: {
			title: '门诊科室详情',
			wechatAuth: true,
			ifBind: true,
		}
	},
	{
		path: '/paySuccess',
		component: () => import('@/views/appointment/paySuccess'),
		meta: {
			title: '挂号支付',
		}
	},
	{
		path: '/yySuccess',
		component: () => import('@/views/appointment/yySuccess'),
		meta: {
			title: '挂号成功',
		}
	},
	{
		path: '/ghxx',
		component: () => import('@/views/appointment/ghxx'),
		meta: {
			title: '我的挂号',
			wechatAuth: true,
			ifBind: true,
		}
	},
	{
		path: '/out_pay',
		component: () => import('@/views/outpatient/pay'),
		meta: {
			title: '门诊缴费',
			wechatAuth: true,
			ifBind: true,
		}
	},
	{
		path: '/outpatient/payType',
		name: 'outpatient_payType',
		component: () => import('@/views/outpatient/payType.vue'),
		meta: {
			title: '订单支付',
			wechatAuth: true
		}
	},
	{
		path: '/outpatient/yjs',
		name: 'outpatient_yjs',
		component: () => import('@/views/outpatient/ybyjs.vue'),
		meta: {
			title: '确定支付',
			wechatAuth: true
		}
	},
	{
		path: '/outpatient/orderSettlement',
		name: 'outpatient_orderSettlement',
		component: () => import('@/views/outpatient/orderSettlement.vue'),
		meta: {
			title: '订单结算',
			wechatAuth: true
		}
	},
	{
		path: '/outpatient/mzjfDetails',
		name: 'outpatient_mzjfDetails',
		component: () => import('@/views/outpatient/mzjfDetails.vue'),
		meta: {
			title: '门诊缴费详情',
			wechatAuth: true
		}
	},
	{
		path: '/out_index',
		name: 'out_index',
		component: () => import('@/views/outpatient/index'),
		meta: {
			title: '历史处方',
			wechatAuth: true,
			ifBind: true,
		}
	}, 
	{
		path: '/out_list',
		component: () => import('@/views/outpatient/list'),
		meta: {
			title: '处方详情',
		}
	}, 
	{
		path: '/card_pay',
		component: () => import('@/views/card/pay'),
		meta: {
			title: '门诊充值',
			wechatAuth: true,
			ifBind: true,
		}
	},
	 {
	 	path: '/card_list',
	 	component: () => import('@/views/card/list'),
	 	meta: {
	 		title: '充值记录',
	 	}
	 }, 
	 {
	 	path: '/in_add',
	 	component: () => import('@/views/inpatient/add'),
	 	meta: {
	 		title: '添加住院号',
			wechatAuth: true,
			ifBind: true,
	 	}
	 }, 
	{
		path: '/inpatientIndex',
		component: () => import('@/views/inpatient/inpatientIndex'),
		meta: {
			title: '住院中心',
			wechatAuth: true,
			ifBind: true,
		}
	}, 
	{
		path: '/in_pay',
		component: () => import('@/views/inpatient/pay'),
		meta: {
			title: '住院充值',
			wechatAuth: true,
			ifBind: true,
		}
	}, 
	{
		path: '/in_paylist',
		component: () => import('@/views/inpatient/paylist'),
		meta: {
			title: '充值记录',
			wechatAuth: true,
			ifBind: true,
		}
	},
	{
		path: '/in_qdlist',
		component: () => import('@/views/inpatient/qdlist'),
		meta: {
			title: '住院清单',
		}
	}, 
	{
		path: '/in_hzlist',
		component: () => import('@/views/inpatient/hzlist'),
		meta: {
			title: '住院汇总',
		}
	}, 
	{
		path: '/tj_cx',
		component: () => import('@/views/physical/TijCX'),
		meta: {
			title: '体检报告查询',
			wechatAuth: true,
			ifBind: true,
		}
	},
	{
		path: '/tj_index',
		component: () => import('@/views/physical/tjbg'),
		meta: {
			title: '报告列表',
		}
	},
	{
		path: '/tj_xq',
		component: () => import('@/views/physical/tjbgxq'),
		meta: {
			title: '报告详情',
		}
	},
	{
		path: '/wdbg',
		component: () => import('@/views/report/wdbg'),
		meta: {
			title: '报告查询',
			wechatAuth: true,
			ifBind: true,
		}
	},
	{
		path: '/bglb',
		component: () => import('@/views/report/bglb'),
		meta: {
			title: '报告列表',
		}
	},
	{
		path: '/lisInfo',
		component: () => import('@/views/report/lisInfo'),
		meta: {
			title: 'LIS报告',
		}
	},
	{
		path: '/pacsInfo',
		component: () => import('@/views/report/pacsInfo'),
		meta: {
			title: 'PACS报告',
		}
	},
	{
		path: '/hesbg',
		component: () => import('@/views/report/hesbg'),
		meta: {
			title: '核酸报告查询',
			wechatAuth: true,
			ifBind: true,
		}
	},
	{
		path: '/hesImage',
		component: () => import('@/views/report/hesImage'),
		meta: {
			title: '核酸报告详情',
			wechatAuth: true,
			ifBind: true,
		}
	},
	{
		path: '/Guidance',
		name: 'Guidance',
		meta: {
			title: '智能导诊',
			wechatAuth: true,
			ifBind: true,
		},
		component: () => import('@/views/hdTCM/zndz/Guidance')
	},
	{
		path: '/problem',
		name: 'problem',
		meta: {
			title: '智能问答',
		},
		component: () => import('@/views/hdTCM/zndz/problem')
	},
	{
		path: '/hesjc',
		component: () => import('@/views/hesjc/hesjcV2'),
		meta: {
			title: '核酸检测',
			wechatAuth: true,
			ifBind: true,
		}
	},
	{
		path: '/jyzn_index',
		component: () => import('@/views/hdTCM/jyzn/index'),
		meta: {
			title: '就医指南',
		}
	},
	{
		path: '/gzys',
		component: () => import('@/views/hdTCM/gzys/index'),
		meta: {
			title: '我的关注',
			wechatAuth: true,
			ifBind: true,
		}
	},
	{
		path: '/message_index',
		component: () => import('@/views/hdTCM/messageCenter/index'),
		meta: {
			title: '消息中心',
			wechatAuth: true,
			ifBind: true,
		}
	},
	{
		path: '/medical_index',
		component: () => import('@/views/hdTCM/medicalFeedback/index'),
		meta: {
			title: '就医评价',
			wechatAuth: true,
			ifBind: true,
		}
	},
	{
		path: '/medical_details',
		component: () => import('@/views/hdTCM/medicalFeedback/details'),
		meta: {
			title: '就医评价',
		}
	},
	{
		path: '/jyzn_xq',
		component: () => import('@/views/hdTCM/jyzn/detail'),
		meta: {
			title: '就医详情',
		}
	},
	{
		path: '/dept_index',
		component: () => import('@/views/hdTCM/doctor/dept_index'),
		meta: {
			title: '科室列表',
		}
	},
	{
		path: '/dept_detail',
		component: () => import('@/views/hdTCM/doctor/dept_detail'),
		meta: {
			title: '科室下医生列表',
		}
	},
	{
		path: '/tsyjy',
		name: 'tsyjy',
		meta: {
			title: '投诉与建议',
			wechatAuth: true,
			ifBind: true,
		},
		component: () => import('@/views/hdTCM/tsyjy/index')
	},
	{
		path: '/xgymList',
		name: 'xgymList',
		meta: {
			title: '新冠调查问卷列表',
			wechatAuth: true
		},
		component: () => import('@/views/hdTCM/xgym/list')
	},
	{
		path: '/xgymAdd',
		name: 'xgymAdd',
		meta: {
			title: '新冠调查问卷',
			wechatAuth: true
		},
		component: () => import('@/views/hdTCM/xgym/index')
	},
	{
		path: '/hsjcInfo',
		name: 'hsjcInfo',
		meta: {
			title: '核酸检测信息录入',
			wechatAuth: true
		},
		component: () => import('@/views/hdTCM/hsjc/info_list')
	},
	{
		path: '/hsjcAdd',
		name: 'hsjcAdd',
		meta: {
			title: '核酸检测信息录入',
			wechatAuth: true
		},
		component: () => import('@/views/hdTCM/hsjc/info_add')
	},
	{
		path: '/basqIndex',
		name: 'basqIndex',
		meta: {
			title: '病案申请列表',
			wechatAuth: true
		},
		component: () => import('@/views/hdTCM/basq/basqIndex')
	},
	{
		path: '/basqAdd',
		name: 'basqAdd',
		meta: {
			title: '病案申请',
			wechatAuth: true //路由需要微信授权
		},
		component: () => import('@/views/hdTCM/basq/components/basqAdd')
	},
	{
		path: '/basqView',
		name: 'basqView',
		meta: {
			title: '病案申请详情',
			wechatAuth: true
		},
		component: () => import('@/views/hdTCM/basq/components/basqView')
	},
	{
		path: '/basqInfo',
		name: 'basqInfo',
		meta: {
			title: '病案申请说明',
			wechatAuth: true
		},
		component: () => import('@/views/hdTCM/basq/components/basqInfo')
	},
	{
		path: '/basqEditInfo',
		name: 'basqEditInfo',
		meta: {
			title: '病案申请修改',
			wechatAuth: true
		},
		component: () => import('@/views/hdTCM/basq/components/basqEditInfo')
	},
	{
		path: '/DzfpCX',
		name: 'DzfpCX',
		meta: {
			title: '电子发票',
			wechatAuth: true,
			ifBind: true,
			isHidFloatBall: true,
		},
		component: () => import('@/views/dzfp/dzfp')
	},
	{
		path: '/Cwgs',
		name: 'Cwgs',
		meta: {
			title: '床位公示',
			wechatAuth: true
		},
		component: () => import('@/views/hdTCM/cwgs/index.vue')
	},
	{
		path: '/sfxm',
		name: 'sfxm',
		meta: {
			title: '收费项目',
			wechatAuth: true
		},
		component: () => import('@/views/hdTCM/sfxm/index.vue')
	},
	{
		path: '/yscz',
		name: 'yscz',
		meta: {
			title: '医生出诊公示',
			wechatAuth: true
		},
		component: () => import('@/views/hdTCM/yscz/index')
	},
	{
		path: '/CommonError/:errorMessage',
		component: () => import('@/views/error/CommonError'),
		meta: {
			title: '错误页面',
			isHidFloatBall: true,
		}
	},
	{
		path: '/WxAuthErr',
		component: () => import('@/views/error/WxAuthErr'),
		meta: {
			title: '授权失败',
			isHidFloatBall: true,
		}
	},
	{
		path: '/viewerDemo',
		component: () => import('@/views/demo/viewerDemo'),
		meta: {
			title: 'viewerDemo',
		}
	}, 
	{
		path: '/storageDemo',
		component: () => import('@/views/demo/storageDemo'),
		meta: {
			title: 'storageDemo',
		}
	}, 
	{
		path: '/moneyFomartDemo',
		component: () => import('@/views/demo/moneyFomartDemo'),
		meta: {
			title: 'moneyFomartDemo',
		}
	}, 
	{
		path: '/selectPatientDemo',
		component: () => import('@/views/demo/selectPatientDemo'),
		meta: {
			title: 'selectPatientDemo',
		}
	},
	{
		path: '/pageDemo',
		component: () => import('@/views/demo/pageDemo'),
		meta: {
			title: 'pageDemo',
		}
	},
	{
		path: '*',
		component: () => import('@/views/notFound'),
		meta: {
			title: '404',
			isHidFloatBall: true,
		}
	}
]
